import React, { useState } from "react";
import Modal from "../../Atoms/Modal/Modal";
import styles from "./CouncilCardInfoModal.module.scss";
import calendarIcon from "../../../assets/Imagess/calendar-black.svg";
import clockIcon from "../../../assets/Imagess/clock-black.svg";
import locationIcon from "../../../assets/Imagess/location-pin-black.svg";
import Buttons from "../../Atoms/Buttons/Buttons";
import { useNavigate } from "react-router-dom";
import arrowLeft from "../../../assets/Imagess/arrow-circle-left.svg";
import arrowRight from "../../../assets/Imagess/arrow-circle-right.svg";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

const CouncilCalendarInfoModal = ({
  calendar,
  handleOnClose,
  setShowDeletePopup,
}) => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [
    calendar?.studentCalendar,
    calendar?.parentCalendar,
    calendar?.cadetCalendar,
    calendar?.facultyCalendar,
  ];

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px' }}
      closeWhite={false}
    >
      <div className={styles['calendar-infocontainer']}>
        <div className={styles['image-container']}>
          <img
            src={arrowLeft}
            className={styles['arrow-left']}
            onClick={handlePreviousImage}
          />
          <img
            src={sanitizeAndValidateUrl(
              `${calendar?.url}${images[currentImageIndex]}`
            )}
            className={styles['modal-image']}
          />
          <img
            src={arrowRight}
            className={styles['arrow-right']}
            onClick={handleNextImage}
          />
        </div>
        <div className={styles['title-container']}>
          <p className={styles['title']}>
            {currentImageIndex == 0
              ? 'Student Council Calendar'
              : currentImageIndex === 1
              ? 'Parent Council Calendar'
              : currentImageIndex === 2
              ? 'Cadets Council Calendar'
              : 'Faculty Council Calendar'}
          </p>
        </div>
        <div className={styles['info-container']}>
          <div className={styles['button-container']}>
            <Buttons
              text="تعديل"
              color="#0DA06E"
              rounded={true}
              style={{ width: '100%' }}
              type="submit"
              handleOnClick={() =>
                navigate(`/home/edit-event/${calendar?.eventId}`)
              }
            />
            <Buttons
              text="حذف"
              color="#D72222"
              rounded={true}
              style={{ width: '100%' }}
              type="submit"
              handleOnClick={() => {
                handleOnClose();
                setShowDeletePopup(true);
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CouncilCalendarInfoModal;
